import { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Loader2 } from 'lucide-react';
import { Link } from "react-router-dom";
import { Card, CardContent, CardFooter, CardHeader } from "src/components/ui/card";
import { Label } from "src/components/ui/label";
import { Input } from "src/components/ui/input";
import { Button } from "src/components/ui/button";
import { Checkbox } from "src/components/ui/checkbox";
import { server1 } from "src/utils/httpsRequest";
export default function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [orgName, setOrgName] = useState("");
  const [imgName, setImgName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [rememberMe, setRememberMe] = useState(false);

  const { org, appid } = useParams(); // Capture org and appid from URL.
  const navigate = useNavigate();
  const location = useLocation();
  const [tenantId, setTenantId] = useState("");
  const getNestedValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  };
  const fetchApplicationKeyValue = async (tenantId, appId, keyPath) => {
    const url = `${server1}/api/v2/applications/list_by_id/${tenantId}/${appId}`;
  
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  
      const data = await response.json();
      const value = getNestedValue(data, keyPath);
  
      if (value !== undefined) {
        return value;
      } else {
        console.warn(`Key path "${keyPath}" not found in response.`);
        return null;
      }
    } catch (error) {
      console.error('Fetch error:', error);
      return null;
    }
  };
  useEffect(() => {
    setTenantId(org || ""); // Dynamically set tenant ID based on orgk
    fetchApplicationKeyValue(
      org, appid,
      'full_name'
    ).then(value => {
      console.log('Full Name:', value); // Output: ""
      setOrgName(value)

    });
    fetchApplicationKeyValue(
      org, appid,
      'settings'
    ).then(value => {
      console.log('Full Name:', value.app_logo); // Output: ""
      setImgName(value.app_logo)

    });
  }, [org]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage(null);

    try {
      const payload = {
        email: username,
        password: password,
        tenant_id: tenantId,
        app_id: appid,
      };
     
    
      // fetchApplicationKeyValue(
      //   org, appid,
      //   'name'
      // ).then(value => {
      //   console.log('Full Name:', value); // Output: ""
      //   setOrgName(value)

      // });

      const response = await fetch(`${server1}/api/v1/users/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Specify JSON content type
          "accept": "application/json",
        },
        body: JSON.stringify(payload), // Pass the payload in the body
      });

      if (response.ok) {
        const result = await response.json();
        localStorage.setItem("userData", JSON.stringify(result));

        // Redirect to the intended page after login
        const redirectTo = new URLSearchParams(location.search).get("redirect");
        navigate(redirectTo || `/DefaultHome?org=${org}&app=${appid}`);
      } else {
        const errorData = await response.json();
        // console.log('errorData',errorData)
        setErrorMessage(errorData?.detail || "An error occurred. Please try again.");
      }
    } catch (error) {
      setErrorMessage(error.message || "An unknown error occurred.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md mb-8">
        <div className="text-center">
          <img
            src={imgName}
            alt="Coolriots Academy"
            width={150}
            height={37}
            className="mx-auto mb-2"
          />
          <h1 className="text-2xl font-bold text-black">{orgName}</h1>
        </div>
      </div>
      <Card className="w-full max-w-md bg-gray-50">
        <CardHeader>
          <h2 className="text-2xl font-semibold text-center text-gray-900">Sign In</h2>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="username">Email Address</Label>
              <Input
                id="username"
                type="email"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full"
              />
            </div>
            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            {/* <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Checkbox
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <label htmlFor="rememberMe" className="text-sm text-gray-600">
                  Remember me
                </label>
              </div>
              <a href={`/${org}/${appid}/ForgotPassword`} className="text-sm text-black hover:underline">
                Forgot password?
              </a>
            </div> */}
            <Button
              type="submit"
              className={`w-full bg-black hover:bg-gray-800 text-white ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Please wait
                </>
              ) : (
                "Sign In"
              )}
            </Button>
          </form>
        </CardContent>
        <CardFooter className="justify-center">
          <p className="text-sm text-gray-600">
            Don&apos;t have an account?{" "}
            <Link to={`/${org}/${appid}/signup`} className="text-black hover:underline">
    Sign Up
</Link>
          </p>
        </CardFooter>
      </Card>
    </div>
  );
}
